<template>
  <div v-if="settings.logos && settings.logos.length > 0" class="w-full">
    <grid-template
        v-if="settings.template === 'grid'"
        :logos="settings.logos"
    />
    <infinite-scroll-template
        v-else-if="settings.template === 'infinite-scroll'"
        :logos="settings.logos"
    />
  </div>
</template>

<script>
import axios from "axios";
import GridTemplate from './layouts/logoGridTemplate.vue';
import InfiniteScrollTemplate from './layouts/logoInfiniteScrollTemplate.vue';

export default {
  name: "LogoShowcaseWidget",
  components: {
    GridTemplate,
    InfiniteScrollTemplate,
  },
  props: ['widgetId'],
  data() {
    return {
      settings: {},
    };
  },
  created() {
    this.fetchWidgetData();
  },
  methods: {
    async fetchWidgetData() {
      try {
        // Construct the API URL, ensuring VUE_APP_API_URL is defined in your .env file
        const apiUrl = (process.env.VUE_APP_API_URL || '') + '/api/widget/' + this.widgetId;
        const response = await axios.get(apiUrl);
        this.settings = response.data;
      } catch (error) {
        console.error("Error fetching logo showcase widget data:", error);
        // Handle error appropriately in your UI
      }
    },
  },
};
</script>
